<div class="page-not-found-container">
    <div class="centered">
        <mat-icon fontSet="phr-iconset" class="icon phr-iconset-search"></mat-icon>  
        <h3 mat-dialog-title>{{ 'notFound.text1' | translate:locale.language }}</h3>
        <div class="text">{{ 'notFound.text2' | translate:locale.language }}</div>       
        <button class="btn" mat-raised-button color="primary" (click)="goHome()">{{ 'notFound.text3' | translate:locale.language }}</button>
    </div>
</div>
